@if (isValidNumber(pourcentage)) {
	@if (pourcentage < 0) {
		<span class="badge rounded-pill fw-medium p-2 bg-primary-subtle text-primary">{{ pourcentage }}</span>
	} @else if (pourcentage < 2.5) {
		<span class="badge rounded-pill fw-medium p-2 bg-success-subtle text-success">{{ pourcentage }}</span>
	} @else if (pourcentage <= 10) {
		<span class="badge rounded-pill fw-medium p-2 bg-warning-subtle text-warning">{{ pourcentage }}</span>
	} @else {
		<span class="badge rounded-pill fw-medium p-2 bg-danger-subtle text-danger">{{ pourcentage }}</span>
	}
}
